(() => {
  if (!customElements.get('bombae-cart-progress')) {
    class BombaeCartProgress extends HTMLElement {
      constructor() {
        super();
        this.tier1 = parseInt(this.dataset.tier1) || 29900;
        this.tier2 = parseInt(this.dataset.tier2) || 200000;
        this.tier3 = parseInt(this.dataset.tier3) || 400000;
      }

      connectedCallback() {
        if (typeof subscribe === 'function') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
            if (e.cart) this.update(e.cart.total_price);
          });
        }
      }

      update(total) {
        const fill = this.querySelector('.bombae-cart-progress__fill');
        const milestones = this.querySelectorAll('.bombae-cart-progress__milestone');

        if (!fill) return;

        // Update progress fill
        const progress = Math.min(100, (total / this.tier3) * 100);
        fill.style.width = progress + '%';

        // Update milestone reached states
        const thresholds = [this.tier1, this.tier2, this.tier3];
        milestones.forEach((m, i) => {
          if (total >= thresholds[i]) {
            m.classList.add('is-reached');
            m.setAttribute('data-reached', '');
          } else {
            m.classList.remove('is-reached');
            m.removeAttribute('data-reached');
          }
        });
      }
    }

    customElements.define('bombae-cart-progress', BombaeCartProgress);
  }
})();
